var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("el-form", {
    ref: "form",
    attrs: {
      "label-width": "80px"
    }
  }, [_vm.temp_id ? _c("el-form-item", {
    attrs: {
      label: "模板ID"
    }
  }, [_c("span", [_vm._v(_vm._s(_vm.temp_id))])]) : _vm._e()], 1), _c("el-form", {
    ref: "form",
    attrs: {
      "label-width": "80px"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "模板名称"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.temp_name,
      callback: function callback($$v) {
        _vm.temp_name = $$v;
      },
      expression: "temp_name"
    }
  })], 1)], 1), _c("div", {
    staticClass: "botStyle"
  }, [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.tempBtn();
      }
    }
  }, [_vm.temp_id == 0 ? _c("span", [_vm._v("保存作为模板")]) : _vm._e(), _vm.temp_id != 0 ? _c("span", [_vm._v("覆盖模板")]) : _vm._e()])], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };